module.exports = __webpack_public_path__ + "img/pitchdeck.9a45d1f1.png";